import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const PURutinMeny: IRutinInfo[] = [
  rutinInfos.rtnProgramAndring,
  rutinInfos.rtnFAQ,
  rutinInfos.rtnUppdatering,
];

export default PURutinMeny;
